var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"give-star"},[_c('p',{staticClass:"level-desc"},[_vm._v(_vm._s(_vm.serverDesc))]),_c('star',{attrs:{"size":"biggest","color":"#ff397e","canClick":true,"score":_vm.level},on:{"clickStar":_vm.getLevel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }